import { useQuery } from "@tanstack/react-query";
import { BulkOperationsResponse, fetchBulkOperationsStatus } from "PFCore/services/bulk_operations";
import { Id, QueryOptions } from "PFCore/types";

import { bulkOperationsKeys } from "./query_keys";

export const useBulkOperationsStatus = (id: Id, options: QueryOptions<BulkOperationsResponse> = {}) =>
  useQuery<BulkOperationsResponse>({
    queryKey: bulkOperationsKeys.status(id),
    queryFn: () => fetchBulkOperationsStatus(id),
    ...options
  });
